import { combineReducers } from 'redux'
import { IPaymentsByTimeOverviewChart } from '../../../types/dashboard'
import { IPagination } from '../../../types/pagination'
import {
  paginatedProjectTimeTrackingInvolvedTasksActivePage,
  paginatedTimeTrackingInvolvedTasks,
  searchProjectTimeTrackingInvolvedTasks,
  sortTimeTrackingInvolvedTasksReport,
} from '../../time-tracking/reducers/timeTrackingReducer'
import {ITimeTracking, ITimeTrackingProject} from '../../time-tracking/types/timeTracking'
import { IActivityFilter, IActivitySearch } from '../types/activityFilters'
import { IProjectBudgetCost, IProjectBudgetCostChart } from '../types/costs'
import {
  ICostFilter,
  ICostHistory,
  ICostSearch,
  ICostSorting,
  IDirectCost,
  IMilestone,
  IMilestoneOfferDirectCost,
  IMilestoneOfferDirectCostMonths,
  IMilestoneOfferDirectCostUpdate,
  IMilestoneSortColumn,
  IPassThroughCost,
} from '../types/directAndPassTroughCosts'
import { IDirectCostInvoice, IPositionPayment, IProjectInvoice } from '../types/invoice'
import {
  IBudgetCostTab,
  ICostBySupplier,
  ICurrentProjectListEntry,
  ICustomer,
  IDepartmentTrend,
  IDirectCostsBulk,
  IInsightsDepartmentHourUtilization,
  IOfferDirectCostsBulk,
  IPassTroughCostsBulk,
  IProject,
  IProjectBudgetChanges,
  IProjectDepartmentsChartData,
  IProjectFilters,
  IProjectLabel,
  IProjectPhase,
  IProjectTypeFilter,
  IProjectsHealthWidget,
  ITrackedHoursByDep,
  InsightsViewType,
  ViewType,
} from '../types/project'
import {
  ICostByMonths,
  ICostsByPhaseChart,
  IExpendituresByLabels,
  IExpendituresByTasks,
  IInsightsDepartmentExpendituresTimeline,
  IInsightsDepartmentExpendituresTimelineChart,
  IProjectActivity,
  IProjectActivityHistory,
  IProjectActivitySorting,
  IProjectCostBurndownWidget,
  IProjectTimeTrackingLabel,
  IProjectTimeTrackingTask,
} from '../types/projectActivity'
import { IWizardProject } from '../types/wizardData'
import { ITimeTrackingInvolvedTasks } from './../../time-tracking/types/timeTracking'
import { IOfferDirectCost, IOfferPassThroughCost } from './../types/directAndPassTroughCosts'
import { IOfferPassThroughCostsBulk, IProjectRecruitmentStatusChanges } from './../types/project'
import {
  accountingTab,
  directCostInvoice,
  directCostInvoices,
  latestPayments,
  nonPaginatedPayments,
  paginatedInvoiceActivePage,
  paginatedInvoices,
  paginatedPaymentsActivePage,
  positionPayments,
  projectInvoice,
  projectInvoices,
  selectedDirectCostInvoice,
  selectedInvoice,
  sortDirectCostInvoices,
  sortInvoices,
  sortPayments,
  sortPtc
} from './accountingReducer'
import {
  actFilters,
  activities,
  activity,
  activityHistory,
  draggableIndicatorAct,
  openActDetailsModal,
  paginatedActivities,
  paginatedActivitiesActivePage,
  searchActivities,
  selectedActivity,
  sortActs,
  sortActsInDanger,
} from './activitiesReducer'
import {
  budgetCost,
  budgetCosts,
  budgetCostsChart,
  budgetCostsCleanData,
  paginatedBudgetCosts,
  paginatedBudgetCostsActivePage
} from './budgetCostsReducer'
import {
  activeSPTBudgetTab,
  costFilters,
  costHistory,
  dcInDangerSorting,
  directCost,
  directCosts,
  draggableIndicator,
  milestoneOfferDirectCosts,
  milestoneOfferDirectCostsForUpdate,
  milestoneUnitTracker,
  milestoneView,
  milestones,
  offerDirectCosts,
  offerPassTroughCosts,
  openCostDetailsModal,
  paginatedDirectCosts,
  paginatedDirectCostsActivePage,
  passTroughCost,
  passTroughCosts,
  searchCosts,
  selectedCost,
  sortCosts,
  sortMilestoneClusteredTasks,
  updatedDirectCosts,
  updatedOfferDirectCosts,
  updatedOfferPassTroughCosts,
  updatedPassTroughCosts
} from './directAndPassTroughCostsReducer'
import {
  budgetCostTabs,
  checkProjectLoader,
  costByMonths,
  costByPhases,
  costDevelopment,
  costDevelopmentStatus,
  costsBySelectedSupplier,
  costsBySupplier,
  customers,
  depCostTimePeriod,
  depCostType,
  depCostYear,
  depHoursUtil,
  depTrendHours,
  departmentCostTrendCurve,
  departmentCostsChartData,
  departmentTimeline,
  departmentTimelinePagination,
  expenditurePhasing,
  expenditurePhasingTimePeriod,
  expenditurePhasingYear,
  expendituresBurndown,
  expendituresByLabels,
  expendituresByTasks,
  expendituresByTasksPagination,
  generalFormActive,
  marginDevelopment,
  marginDevelopmentType,
  paginatedDepartmentTimelineActivePage,
  paginatedExpendituresByTasksActivePage,
  paginatedProjectTimeTrackingActivePage,
  paginatedProjectTimeTrackingLabelsActivePage,
  paginatedProjectTimeTrackingTasksActivePage,
  paymentForecast,
  paymentForecastTimePeriod,
  paymentForecastYear,
  paymentsByTime,
  paymentsByTimePeriod,
  paymentsByTimeYear,
  projCostDevType,
  projCostDevYear,
  project,
  projectActivities,
  projectBudgetChanges,
  projectInsightsViewType,
  projectLabelListUpdate,
  projectPhaseListUpdate,
  projectPlannerViewType,
  projectProjectTimeTrackingTasksPagination,
  projectRecruitmentStatusChanges,
  projectTimeTracking,
  projectTimeTrackingLabels,
  projectTimeTrackingLabelsPagination,
  projectTimeTrackingPagination,
  projectTimeTrackingTasks,
  receiptForecast,
  receiptForecastTimePeriod,
  receiptForecastYear,
  recruitmentCosts,
  recruitmentCostsType,
  recruitmentCostsYear,
  recruitmentType,
  restrictedPhases,
  searchDepCostUtilization,
  searchExpendituresByTasks,
  searchProjectTimeTracking,
  sortTimeTrackingReport,
  trackedHoursByDep
} from './projectReducer'
import {
  currentProjectsList,
  filterProjects,
  projectSort,
  projectTypeFilter,
  projectTypeFilters,
  projects,
  projectsCountAll,
  projectsActiveCount,
  projectsHealthWidget,
  projectsTTList,
} from './projectsReducer'
import wizardApp from './wizardReducer'

export interface ProjectsState {
  projects: IProject[]
  project: IProject
  projectActivities: IProjectActivity[]
  actFilters: IActivityFilter[]
  wizardApp: {
    wizardStep: string
    projectWizardData: IWizardProject
    wizardFinishedSteps: number[]
  }
  projectPlannerViewType: ViewType
  activities: IProjectActivity[]
  searchActivities: IActivitySearch
  sortActs: IProjectActivitySorting
  sortActsInDanger: IProjectActivitySorting
  filterProjects: IProjectFilters
  projectInsightsViewType: InsightsViewType
  activity: IProjectActivity
  projectsCountAll: number
  projectsActiveCount: number
  selectedActivity: IProjectActivity
  activityHistory: IProjectActivityHistory[]
  projectPhaseListUpdate: IProjectPhase[]
  generalFormActive: boolean
  projectLabelListUpdate: IProjectLabel[]
  departmentCostsChartData: IProjectDepartmentsChartData
  openActDetailsModal: boolean
  budgetCosts: IProjectBudgetCost[]
  budgetCostsCleanData: IProjectBudgetCost[]
  budgetCost: IProjectBudgetCost
  departmentTimeline: IInsightsDepartmentExpendituresTimelineChart
  expendituresBurndown: IProjectCostBurndownWidget
  projectTimeTracking: ITimeTracking[]
  projectTimeTrackingPagination: IPagination<ITimeTracking[]>
  paginatedTimeTrackingInvolvedTasks: IPagination<ITimeTrackingInvolvedTasks[]>
  paginatedProjectTimeTrackingActivePage: number
  paginatedProjectTimeTrackingInvolvedTasksActivePage: number
  searchProjectTimeTracking: Record<string, string>
  searchProjectTimeTrackingInvolvedTasks: Record<string, string>
  expendituresByLabels: IExpendituresByLabels[]
  costByMonths: ICostByMonths[]
  projectTimeTrackingLabels: IProjectTimeTrackingLabel[]
  projectTimeTrackingLabelsPagination: IPagination<IProjectTimeTrackingLabel[]>
  paginatedProjectTimeTrackingLabelsActivePage: number
  projectTimeTrackingTasks: IProjectTimeTrackingTask[]
  projectProjectTimeTrackingTasksPagination: IPagination<IProjectTimeTrackingTask[]>
  paginatedProjectTimeTrackingTasksActivePage: number
  costByPhases: ICostsByPhaseChart
  expendituresByTasks: IExpendituresByTasks[]
  expendituresByTasksPagination: IPagination<IExpendituresByTasks[]>
  paginatedExpendituresByTasksActivePage: number
  departmentTimelinePagination: IInsightsDepartmentExpendituresTimeline
  paginatedDepartmentTimelineActivePage: number
  searchDepCostUtilization: { search: string }
  searchExpendituresByTasks: { search: string }
  depHoursUtil: IInsightsDepartmentHourUtilization
  departmentCostTrendCurve: IInsightsDepartmentExpendituresTimelineChart
  depTrendHours: IDepartmentTrend
  trackedHoursByDep: ITrackedHoursByDep[]
  projectBudgetChanges: IProjectBudgetChanges[]
  projectInvoice: IProjectInvoice
  projectInvoices: IProjectInvoice[]
  selectedInvoice: IProjectInvoice
  sortInvoices: { name: string; direction: string }
  budgetCostTabs: IBudgetCostTab[]
  sortTimeTrackingReport: { name: string; direction: string }
  sortTimeTrackingInvolvedTasksReport: { name: string; direction: string }
  budgetCostsChart: IProjectBudgetCostChart
  projectTypeFilters: IProjectTypeFilter[]
  projectTypeFilter: IProjectTypeFilter
  projectSort: { name: string; direction: string }
  directCosts: IDirectCost[]
  passTroughCosts: IPassThroughCost[]
  selectedCost: IDirectCost | IPassThroughCost
  costFilters: ICostFilter[]
  sortCosts: ICostSorting
  dcInDangerSorting: ICostSorting
  searchCosts: ICostSearch
  directCost: IDirectCost
  passTroughCost: IPassThroughCost
  openCostDetailsModal: boolean
  costHistory: ICostHistory[]
  positionPayments: IPagination<IPositionPayment[]>
  nonPaginatedPayments: IPositionPayment[]
  sortPayments: { name: string; direction: string }
  paginatedPaymentsActivePage: number
  paginatedInvoices: IPagination<IProjectInvoice[]>
  accountingTab: string
  paginatedInvoiceActivePage: number
  costsBySupplier: ICostBySupplier[]
  costsBySelectedSupplier: string
  directCostInvoices: IDirectCostInvoice[]
  directCostInvoice: IDirectCostInvoice
  selectedDirectCostInvoice: IDirectCostInvoice
  sortDirectCostInvoices: { name: string; direction: string }
  updatedDirectCosts: IDirectCostsBulk
  updatedPassTroughCosts: IPassTroughCostsBulk
  customers: ICustomer[]
  activeSPTBudgetTab: string
  offerDirectCosts: IOfferDirectCost[]
  offerPassTroughCosts: IOfferPassThroughCost[]
  updatedOfferDirectCosts: IOfferDirectCostsBulk
  updatedOfferPassTroughCosts: IOfferPassThroughCostsBulk
  paymentsByTime: IPaymentsByTimeOverviewChart
  paymentsByTimePeriod: string
  paymentForecast: IPaymentsByTimeOverviewChart
  paymentForecastTimePeriod: string
  receiptForecast: IPaymentsByTimeOverviewChart
  receiptForecastTimePeriod: string
  latestPayments: IProjectInvoice[]
  expenditurePhasing: IPaymentsByTimeOverviewChart
  expenditurePhasingTimePeriod: string
  depCostTimePeriod: string
  costDevelopment: IPaymentsByTimeOverviewChart
  costDevelopmentStatus: string
  projectRecruitmentStatusChanges: IProjectRecruitmentStatusChanges[]
  recruitmentCosts: IPaymentsByTimeOverviewChart
  recruitmentType: string
  marginDevelopment: IPaymentsByTimeOverviewChart
  marginDevelopmentType: string
  depCostYear: number
  depCostType: string
  projCostDevType: string
  projCostDevYear: number
  recruitmentCostsYear: number
  recruitmentCostsType: string
  expenditurePhasingYear: number
  paymentsByTimeYear: number
  paymentForecastYear: number
  receiptForecastYear: number
  checkProjectLoader: boolean
  draggableIndicator: boolean
  draggableIndicatorAct: boolean
  projectsTTList: ITimeTrackingProject[]
  currentProjectsList: ICurrentProjectListEntry[]
  paginatedActivities: IPagination<IProjectActivity[]>
  paginatedActivitiesActivePage: number
  paginatedDirectCosts: IPagination<IDirectCost[]>
  paginatedDirectCostsActivePage: number
  paginatedBudgetCosts: IPagination<IProjectBudgetCost[]>
  paginatedBudgetCostsActivePage: number
  restrictedPhases: number[]
  milestoneView: 'overview' | 'unit_tracker'
  sortMilestoneClusteredTasks: IMilestoneSortColumn
  milestoneOfferDirectCosts: IMilestoneOfferDirectCost[]
  milestones: IMilestone[]
  milestoneOfferDirectCostsForUpdate: IMilestoneOfferDirectCostUpdate[]
  milestoneUnitTracker: IMilestoneOfferDirectCostMonths[]
  projectsHealthWidget: IProjectsHealthWidget
  sortPtc: { name: string; direction: string }
}

const projctsApp = combineReducers<ProjectsState>({
  projects,
  project,
  projectActivities,
  actFilters,
  wizardApp,
  projectPlannerViewType,
  activities,
  searchActivities,
  sortActs,
  filterProjects,
  projectInsightsViewType,
  activity,
  projectsCountAll,
  projectsActiveCount,
  selectedActivity,
  activityHistory,
  projectPhaseListUpdate,
  generalFormActive,
  projectLabelListUpdate,
  departmentCostsChartData,
  openActDetailsModal,
  budgetCosts,
  budgetCost,
  departmentTimeline,
  expendituresBurndown,
  projectTimeTracking,
  projectTimeTrackingPagination,
  paginatedTimeTrackingInvolvedTasks,
  paginatedProjectTimeTrackingActivePage,
  paginatedProjectTimeTrackingInvolvedTasksActivePage,
  searchProjectTimeTracking,
  searchProjectTimeTrackingInvolvedTasks,
  expendituresByLabels,
  costByMonths,
  projectTimeTrackingLabels,
  projectTimeTrackingTasks,
  projectProjectTimeTrackingTasksPagination,
  paginatedProjectTimeTrackingTasksActivePage,
  costByPhases,
  expendituresByTasks,
  expendituresByTasksPagination,
  paginatedExpendituresByTasksActivePage,
  departmentTimelinePagination,
  paginatedDepartmentTimelineActivePage,
  searchDepCostUtilization,
  searchExpendituresByTasks,
  depHoursUtil,
  departmentCostTrendCurve,
  depTrendHours,
  trackedHoursByDep,
  projectBudgetChanges,
  projectInvoice,
  projectInvoices,
  selectedInvoice,
  sortInvoices,
  budgetCostTabs,
  sortTimeTrackingReport,
  sortTimeTrackingInvolvedTasksReport,
  budgetCostsChart,
  projectTypeFilters,
  projectTypeFilter,
  projectSort,
  directCosts,
  passTroughCosts,
  selectedCost,
  costFilters,
  sortCosts,
  searchCosts,
  directCost,
  passTroughCost,
  openCostDetailsModal,
  costHistory,
  positionPayments,
  nonPaginatedPayments,
  sortPayments,
  paginatedPaymentsActivePage,
  paginatedInvoices,
  accountingTab,
  paginatedInvoiceActivePage,
  costsBySupplier,
  costsBySelectedSupplier,
  directCostInvoices,
  directCostInvoice,
  selectedDirectCostInvoice,
  sortDirectCostInvoices,
  updatedDirectCosts,
  updatedPassTroughCosts,
  customers,
  activeSPTBudgetTab,
  offerDirectCosts,
  offerPassTroughCosts,
  updatedOfferDirectCosts,
  updatedOfferPassTroughCosts,
  paymentsByTime,
  paymentsByTimePeriod,
  paymentForecast,
  paymentForecastTimePeriod,
  receiptForecast,
  receiptForecastTimePeriod,
  latestPayments,
  expenditurePhasing,
  expenditurePhasingTimePeriod,
  depCostTimePeriod,
  costDevelopment,
  costDevelopmentStatus,
  projectRecruitmentStatusChanges,
  recruitmentCosts,
  recruitmentType,
  budgetCostsCleanData,
  marginDevelopment,
  projectTimeTrackingLabelsPagination,
  paginatedProjectTimeTrackingLabelsActivePage,
  depCostYear,
  depCostType,
  projCostDevType,
  projCostDevYear,
  recruitmentCostsYear,
  recruitmentCostsType,
  expenditurePhasingYear,
  marginDevelopmentType,
  paymentsByTimeYear,
  paymentForecastYear,
  receiptForecastYear,
  sortActsInDanger,
  dcInDangerSorting,
  checkProjectLoader,
  draggableIndicator,
  draggableIndicatorAct,
  projectsTTList,
  currentProjectsList,
  paginatedActivities,
  paginatedActivitiesActivePage,
  paginatedDirectCosts,
  paginatedDirectCostsActivePage,
  paginatedBudgetCosts,
  paginatedBudgetCostsActivePage,
  restrictedPhases,
  milestoneView,
  sortMilestoneClusteredTasks,
  milestoneOfferDirectCosts,
  milestones,
  milestoneOfferDirectCostsForUpdate,
  milestoneUnitTracker,
  projectsHealthWidget,
  sortPtc
})

export default projctsApp
